"use strict";
exports.__esModule = true;
exports.getKeyByValue = void 0;
function getKeyByValue(object, value) {
    return Object.keys(object).find(function (key) { return object[key] === value; });
}
exports.getKeyByValue = getKeyByValue;
